"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Utility_1 = require("../Utility");
var Tabs = function (props, ref) {
    var _a;
    var _b = (0, Utility_1.handleUtility)(props), className = _b.className, defaultSelected = _b.defaultSelected, onSelectChange = _b.onSelectChange, setTab = _b.setTab, _c = _b.tabs, tabs = _c === void 0 ? [] : _c, rest = __rest(_b, ["className", "defaultSelected", "onSelectChange", "setTab", "tabs"]);
    var _d = React.useState((defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.id) || ((_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.id)), selected = _d[0], setSelected = _d[1];
    var _e = React.useState(), lastTab = _e[0], setLastTab = _e[1];
    var onTabClick = function (tab) {
        setLastTab(tab.id);
        setSelected(tab.id);
        if (onSelectChange)
            onSelectChange(tab);
    };
    React.useEffect(function () {
        if (setTab && Boolean((setTab === null || setTab === void 0 ? void 0 : setTab.id) !== lastTab) && !setTab.disabled) {
            setLastTab(setTab.id);
            setSelected(setTab.id);
            if (onSelectChange)
                onSelectChange(setTab);
        }
    }, [lastTab, onSelectChange, setTab]);
    React.useImperativeHandle(ref, function () { return ({
        selectedTab: selected,
        setTab: onTabClick,
    }); });
    return (React.createElement("ul", __assign({ role: 'listbox', className: (0, classnames_1.default)('t2-tabs', className) }, rest), tabs.map(function (tab) {
        var id = tab.id, name = tab.name, disabled = tab.disabled;
        return (React.createElement("li", { role: 'option', key: id, className: (0, classnames_1.default)({
                't2-selected': selected === id,
                't2-disabled': disabled,
            }), onClick: function () { return !disabled && onTabClick(tab); } }, name));
    })));
};
exports.default = React.forwardRef(Tabs);
